import React, { useEffect, useState } from "react"
import useReportColumns from "hooks/useReportColumns"
import { REPORT_COLUMN_KEYS } from "config/reportColumnDefinitions"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import {
  getProviderItemCategories,
  getProviderProjects,
} from "store/provider-dashboard/provider-dashboard-action"
import {
  exportProviderQuantificationReport,
  getProviderQuantificationReport,
} from "store/provider-reports/p-report-action"
import ProviderQuantificationReportListComponent from "components/ProviderReports/Quantification"

const ProviderQuantificationReport = () => {
  //meta title
  document.title = "Quantification Report"

  const [params, setParams] = useState({})
  const { data, error, loading, exportStatus } = useSelector(state => ({
    data: state.providerReports.providerQuantificationReport.data,
    error: state.providerReports.providerQuantificationReport.error,
    loading: state.providerReports.providerQuantificationReport.loading,
    exportStatus: state.providerReports.providerQuantificationExport,
  }))

  const dispatch = useDispatch()
  const { columns, visibleColumns, visibleKeys, toggleColumn } = useReportColumns(
    REPORT_COLUMN_KEYS.PROVIDER_QUANTIFICATION
  )

  // Trigger export process when Export button is clicked
  const onExport = () => {
    dispatch(exportProviderQuantificationReport(params, visibleKeys))
  }

  // fetch quanitificatin report and other data for filter select box
  useEffect(() => {
    dispatch(getProviderQuantificationReport())
    dispatch(getProviderProjects())
    dispatch(getProviderItemCategories())
  }, [])

  // Updates search value when a new search is performed
  const onSearchHandler = filter => {
    setParams(filter)
    dispatch(getProviderQuantificationReport(filter))
  }

  return (
    <React.Fragment>
      <Breadcrumbs
        title={"Provider"}
        breadcrumbItem={"Quantification Report"}
      />
      {/* Provider Quantification Report List Component  */}
      <ProviderQuantificationReportListComponent
        data={data}
        error={error}
        loading={loading}
        onSearchHandler={onSearchHandler}
        onExportBtnClick={onExport}
        exportStatus={exportStatus}
        columns={columns}
        visibleColumns={visibleColumns}
        onToggleColumn={toggleColumn}
      />
    </React.Fragment>
  )
}

export default ProviderQuantificationReport
